// eslint-disable-next-line import/no-anonymous-default-export
export default /* glsl */`

float ambientOcclusion;
if (uv1AOMap){
	ambientOcclusion = ( texture2D( aoMap, vUv ).r - 1.0 ) * aoMapIntensity + 1.0;
} else {
	ambientOcclusion = ( texture2D( aoMap, vUv2 ).r - 1.0 ) * aoMapIntensity + 1.0;
}
`;